import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'serviceManagementExperience.listExport'

const ServiceManagementServiceListExportSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default ServiceManagementServiceListExportSlice
